import { type ReactElement, Suspense, lazy } from 'react';
import { Route, Routes } from 'react-router-dom';

import { Landing } from './routes/Landing';

// Editor route dynamically loads the PDF engine (pdfjs-dist plus its
// worker) via `getEngine()` — see `src/app/engine.ts`. React.lazy
// keeps the Editor component + its transitive imports out of the
// Landing chunk. First navigation to /edit shows the Suspense
// fallback while the chunk loads. Chunk size is verified per
// P-01.14 performance-shipping-gates in the Playwright + bundle-
// budget checks landing with #39.
const Editor = lazy(async () => import('./routes/Editor'));

export function App(): ReactElement {
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route
        path="/edit"
        element={
          <Suspense fallback={<EditorLoading />}>
            <Editor />
          </Suspense>
        }
      />
    </Routes>
  );
}

function EditorLoading(): ReactElement {
  return (
    <main
      className="flex min-h-screen items-center justify-center px-6 text-chrome-text-secondary"
      aria-label="Loading editor"
      aria-busy="true"
      aria-live="polite"
    >
      Loading editor…
    </main>
  );
}
